import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var Pane = styled(Box).withConfig({
  displayName: "styled__Pane",
  componentId: "sc-16zc95q-0"
})(["background-color:white;border-radius:3px;", ";", ";", ";", ";", ";&{", ";}"], function (props) {
  return props.styledBorder !== 'shadow' && typeof props.styledBorder !== 'boolean' ? "border: " + props.styledBorder : null;
}, function (props) {
  return props.styledBorder === 'shadow' && css(["box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1),0px 0px 0px 1px rgba(0,0,0,0.1);&{", ";}"], theme('fannypack.Pane.border.shadow'));
}, function (props) {
  return props.elevation && css(["box-shadow:0px ", "px ", "px 0px rgba(0,0,0,0.1),0px 0px 0px 1px rgba(0,0,0,0.1);"], function (props // @ts-ignore
  ) {
    return theme("fannypack.Pane.elevations." + props.elevation)(props) / 2;
  }, theme("fannypack.Pane.elevations." + props.elevation));
}, function (props) {
  return props.styledBorder === true && css(["border:1px solid ", ";&{", ";}"], palette('white800'), theme('fannypack.Pane.border.default'));
}, function (props) {
  return props.isFullWidth && css(["width:100%;"]);
}, theme('fannypack.Pane.base'));
export default Pane;
export { Pane };